import { Injectable } from "@angular/core";
import { User } from "./user.model";
import { UserStore } from "./user.store";

/** A service used to access the IDRH of the user */
@Injectable()
export class UserStoreDefaultImpl implements UserStore {
  public get(): User {
    return { idrh: "", token: "" };
  }

  public isUserValid(): boolean {
    return true;
  }

  public isMissingRequiredUser(): boolean {
    return false;
  }

  public set(_user: User): void {
    /* No-op implementation */
  }
}
